export function stringToBoolean(value) {
    if (typeof value === 'string') {
        if (value === "true" || value === "1") {
            return true;
        } else if (value === "false" || value === "0") {
            return false;
        }
    }
    return value; // Return the original value if it's not a valid boolean string
}

export function isEmpty(value) {
    return (
        (typeof value === 'string' && value.length === 0) ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === 'object' && value !== null && Object.keys(value).length === 0) ||
        (typeof value === 'number' && value === 0) ||
        (value === null || value === undefined) ||
        (value instanceof Map && value.size === 0)
    );
}

export function arraysAreEqual(arr1, arr2) {
    return JSON.stringify(arr1) === JSON.stringify(arr2);
}

export function numberFormat(value, minimumFractionDigits = 0, maximumFractionDigits = 20, useGrouping= false){
    value = value.replace(/\.|,/g, "");
    return new Intl.NumberFormat('de-DE', {
        'minimumFractionDigits' : minimumFractionDigits,
        'maximumFractionDigits' : maximumFractionDigits,
        'useGrouping' : useGrouping
    }).format(value);
}
